import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import "./index.scss";
import { defaultAccessDenied } from "../../assets/lottie-animations/animationOptions";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="access-container">
      <div className="access-anim">
        <Lottie options={defaultAccessDenied} height={260} width={260} />
      </div>
      <h2>Access denied</h2>
      <p>You don't have permission to view this page.</p>
      <button className="access-home-btn" onClick={() => navigate("/acceuil")}>
        Back to home
      </button>
    </div>
  );
};

export default AccessDenied;
